// src/apiService.js

import axiosClient from './axiosClient'; // Import the Axios client

// Function to fetch discount codes
const getDiscountCodes = async () => {
    try {
        const response = await axiosClient.get('/discount-code'); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching discount codes:', error);
        throw error; // Rethrow the error for further handling
    }
};

const getDiscountCodeDetail = async (id) => {
    try {
        const response = await axiosClient.get(`/discount-code/${id}`); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching discount codes:', error);
        throw error; // Rethrow the error for further handling
    }
};

const createDiscountCode = async (formData) => {
    try {
        const response = await axiosClient.post('/discount-code', formData, {
            headers: {
                'Content-Type': 'application/json', // For file uploads
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error creating discount code:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// DELETE discount code by ID
const deleteDiscountCode = async (id) => {
    try {
        const response = await axiosClient.delete(`/discount-code/${id}`);
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error deleting discount code:', error);
        throw error; // Rethrow error for handling in the component
    }
};

// PATCH discount code by ID
const updateDiscountCode = async (id, formData) => {
    try {
        const response = await axiosClient.patch(`/discount-code/${id}`, formData, {
            headers: {
                'Content-Type': 'application/json', // For file uploads
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error updating discount code:', error);
        throw error; // Rethrow error for handling in the component
    }
};

const updateSettings = async (formData) => {
    try {
        const response = await axiosClient.patch(`/discount-code/settings`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // For file uploads
            },
        });
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error updating discount code:', error);
        throw error; // Rethrow error for handling in the component
    }
};

const getSettingDetail = async () => {
    try {
        const response = await axiosClient.get(`/discount-code/settings`);
        return response.data; // Return the response data
    } catch (error) {
        console.error('Error fetching settings', error);
        throw error; // Rethrow error for handling in the component
    }
};

const getDiscountCodeDetailByCode = async (id) => {
    try {
        const response = await axiosClient.get(`/discount-code/code/${id}`); // API call
        return response.data; // Return the data from the response
    } catch (error) {
        console.error('Error fetching discount codes:', error);
        throw error; // Rethrow the error for further handling
    }
};

// Export the function
export { getDiscountCodes, deleteDiscountCode, createDiscountCode, updateDiscountCode, getDiscountCodeDetail, getDiscountCodeDetailByCode, updateSettings, getSettingDetail };
